function objectFit(parentContainer = document, className = "object-fit") {
	if ('objectFit' in document.documentElement.style === false) {
		const container = parentContainer.getElementsByClassName(className);
		let imageSource;
		let i;

		for (i = 0; i < container.length; i++) {
			imageSource = container[i].querySelector('img').src;

			container[i].querySelector('img').style.display = 'none';
			container[i].style.backgroundSize = 'cover';
			container[i].style.backgroundImage = 'url(' + imageSource + ')';
			container[i].style.backgroundPosition = 'center center';
			container[i].style.backgroundRepeat = 'no-repeat';
		}
	}
}

module.exports = objectFit;


// WEBPACK FOOTER //
// ./resources/js/modules/object-fit.js